package app.nestbridge.feature.common.screen

import androidx.compose.runtime.Immutable
import com.karawek.core.circuit.Parcelize
import com.slack.circuit.runtime.CircuitUiState
import com.slack.circuit.runtime.screen.Screen

@Parcelize
data class DocumentViewerScreen(
    val document: DocumentKind,
) : Screen {
    enum class DocumentKind(
        val resourcePath: String,
        val title: String,
    ) {
        Terms("files/terms_and_conditions.txt", "Terms & Conditions"),
        Privacy("files/privacy_policy.txt", "Privacy Policy"),
    }
}

@Immutable
data class DocumentViewerState(
    val title: String,
    val content: String = "",
    val isLoading: Boolean = false,
    val eventSink: (DocumentViewerEvent) -> Unit = {},
) : CircuitUiState

sealed interface DocumentViewerEvent {
    data object OnAppear : DocumentViewerEvent
    data object Close : DocumentViewerEvent
}

